import './TeamSelector.scss';

import * as React from 'react';

import { SlOption, SlSelect } from '@shoelace-style/shoelace/dist/react';
import { TeamRole } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import { useAtom } from 'jotai';

import { SmallButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/standard';
import { Spinner } from '~shared/components/Spinner';
import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useSelectInitialTeamId } from '~teacher/components/Account/hooks';
import { RenameTeamDialog } from '~teacher/components/Account/RenameTeamDialog';
import { useAccount } from '~teacher/hook/account';
import { useTeams, useTeamsMembers } from '~teacher/hook/team';

export function TeamSelector() {
  useSelectInitialTeamId();
  const teamsQuery = useTeams();
  const currentUserPublicIdQuery = useAccount({
    select: (data) => data.publicId,
  });

  const [selectedTeamId, setSelectedTeamId] = useAtom(selectedTeamIdAtom);
  const [isRenameDialogOpen, setIsRenameDialogOpen] = React.useState(false);
  const currentUserTeamData = useTeamsMembers({
    teamId: selectedTeamId,
    select: (data) =>
      data.find((member) => member.publicId === currentUserPublicIdQuery?.data),
  });

  if (
    teamsQuery.isLoading ||
    currentUserPublicIdQuery.isLoading ||
    currentUserTeamData.isLoading
  ) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="grid gap-2 col-span-2 grid-cols-subgrid">
      <SlSelect
        className="viewing-subscription-select flex-1 max-w-3xl"
        value={`${selectedTeamId}`}
        label={translate('Viewing Team:')}
        id="team"
        onSlChange={(e) => {
          setSelectedTeamId((e.target as HTMLInputElement).value);
        }}
      >
        {(teamsQuery.data ?? []).map(({ id, displayName }) => (
          <SlOption key={id} value={`${id}`} selected={id === selectedTeamId}>
            {displayName}
          </SlOption>
        ))}
        <div slot="expand-icon" className="text-grey-600">
          <IconChevron />
        </div>
      </SlSelect>
      {[TeamRole.Owner, TeamRole.Admin].includes(
        currentUserTeamData?.data?.role
      ) ? (
        <div className="grid auto-rows-min items-end content-end">
          <SmallButton
            className="whitespace-no-wrap w-70 md:w-full"
            onClick={() => {
              setIsRenameDialogOpen(true);
            }}
          >
            {translate('Rename Team')}
          </SmallButton>
        </div>
      ) : null}

      <RenameTeamDialog
        isOpen={isRenameDialogOpen}
        onClose={() => setIsRenameDialogOpen(false)}
      />
    </div>
  );
}
